// Shared UDS Button tokens for the paired CTAs on the activation error/notice
// screens (Figma H1 / HH1): a filled black primary next to an outlined
// secondary. Kept in one place so consumer and dealer stay in sync.
// borderRadius stays 0 on the button itself: the wrapper owns the rounding and
// clips to it. Rounding both left hairline gaps at the corners where the
// button's curve pulled away from the wrapper's (tighter) inner curve.
const CTA_SHAPE_TOKENS = {
  borderRadius: 0,
  paddingLeft: 32,
  paddingRight: 32
}

// The kit's own border rendered inconsistently on the outlined button (the
// bottom edge went missing), so the outline is drawn by the wrapper element
// instead and both buttons are borderless. Both wrappers carry the same 1px
// box so the two CTAs are geometrically identical and render the same height —
// on the filled button the black border simply blends into the black fill.
export const PRIMARY_CTA_TOKENS = {
  ...CTA_SHAPE_TOKENS,
  backgroundColor: '#000000',
  color: '#ffffff',
  borderWidth: 0
}

export const SECONDARY_CTA_TOKENS = {
  ...CTA_SHAPE_TOKENS,
  backgroundColor: '#ffffff',
  color: '#000000',
  borderWidth: 0
}

// overflow-hidden clips the button to the wrapper's rounded corners; the
// matching background means any sub-pixel seam shows the button's own colour
// rather than the page behind it. Both wrappers carry the same 1px box so the
// two CTAs stay exactly the same height.
const CTA_WRAPPER_BASE = 'w-full sm:w-auto rounded-[2px] border border-solid border-black overflow-hidden'

export const PRIMARY_CTA_WRAPPER = `${CTA_WRAPPER_BASE} bg-black`

export const SECONDARY_CTA_WRAPPER = `${CTA_WRAPPER_BASE} bg-white`
